import { ChangeDetectorRef, Component } from "@angular/core";
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { fadeInUp400ms } from "@vex/animations/fade-in-up.animation";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { NgIf } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { AuthService } from "../../../services/auth.service";
import { UserService } from "src/app/services/user.service";
import { User, UserCredential } from "@angular/fire/auth";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarService } from "src/app/services/snackbar.service";

@Component({
  selector: "vex-register",
  templateUrl: "./sign-up.component.html",
  styleUrls: ["./sign-up.component.scss"],
  animations: [fadeInUp400ms],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    NgIf,
    MatIconModule,
    MatCheckboxModule,
    RouterLink,
  ],
})
export class SignUpComponent {
  form = this.fb.group({
    email: ["", Validators.email],
    password: ["", Validators.required],
  });

  inputType = "password";
  visible = false;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    private as: AuthService,
    private us: UserService,
    private snackbar: SnackbarService,
  ) {}

  signUp(user: User): void {
    this.us.setUser$(user);
    this.us.setUser(user);
    this.router.navigate(["/dashboard"]);
  }

  signUpWithEmailAndPassword() {
    if (this.form.valid) {
      const email: string = this.form.controls['email'].value || '';
      const password: string = this.form.controls['password'].value || '';
      this.as.signUpUserWithEmailAndPassword(email, password).then((response) => {
        this.signUp(response.user)
      }).catch((error) => {
        this.snackbar.error(error);
      })
    } else {
      this.snackbar.error('Please provide email and password');
    }
  }

  signUpWithGoogle(): void {
    this.as
      .signInWithGoogle()
      .then((response: UserCredential) => {
        this.signUp(response.user);
      })
      .catch(() => {});
  }

  signUpWithFacebook(): void {
    this.as
      .signInWithFacebook()
      .then((response: UserCredential) => {
        this.signUp(response.user);
      })
      .catch(() => {});
  }

  signUpWithTwitter(): void {
    this.as
      .signInWithTwitter()
      .then((response: UserCredential) => {
        this.signUp(response.user);
      })
      .catch(() => {});
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = "password";
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = "text";
      this.visible = true;
      this.cd.markForCheck();
    }
  }
}
